// axios.ts
import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';
import type { Response } from './types';
import { readAccessToken } from '../auth';
import { readAppVersion } from '../device/device';
import { platform, getVisitFrom, isWhichMina } from '../device/platform'

axios.defaults.baseURL = process.env.VITE_APP_BASE_URL;
axios.defaults.timeout = 1000 * 60;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';



// axios实例
const service = axios.create({
  // 根据不同env设置不同的baseURL
  baseURL: process.env.VITE_APP_BASE_URL
})

// axios实例拦截请求
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    config.headers = {
      version: readAppVersion(),
      fromVersion: readAppVersion(),
      token: readAccessToken(),
      visitFrom: getVisitFrom(),
      Authorization: readAccessToken(), // 注意这个获取的是，供应商系统里需要，如果要更换取值
      'app-type': isWhichMina(),
      ...config.headers
    };
    if (config.host) {
      console.log('process.env0', process.env)
      const tempUrl = process.env[`VITE_APP_BASE_API_${config.host}`]
      console.log('tempUrl', tempUrl)
      config.baseURL = tempUrl
    }
    console.log('axios实例拦截请求', config)
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// axios实例拦截响应
service.interceptors.response.use(
  (response: AxiosResponse<Response>) => {
    if (response.status !== 200) {
      return Promise.reject(response);
    }
    if (response.config.codeRes === 'resolve') {
      return response;
    } else {
      const { code, msg } = response.data;
      // php 接口返回的code 1 代表成功，0 代表失败
      const isSapi = response.config?.url?.includes('/sapi/shop') && code == 1
      if (code === 0 || code === 200 || isSapi) {
        return response;
      } else {
        return Promise.reject(response)
      }
    }
  },
  (error: AxiosError) => {

    return Promise.reject(error);
  }
);

export type { AxiosResponse, AxiosRequestConfig };

export default service;


